<div #chart_anchor>Chart to appear here</div>
